export function objectsEqual<T extends object>(a: T, b: T): boolean {
    let key: keyof T;
    for (key in a) {
        if (a[key] !== b[key]) {
            return false;
        }
    }
    for (key in b) {
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
